<template>
  <div class="custom-container" id="ticket-view" v-if="ticketData.conversation">
    <b-container fluid class="">
      <b-row class="mb-3">
        <b-col cols="12">
          <PageHeader
              :title="ticketData.subject"
              :special-back-link="true"
              :enable-back-link="true"
              @goBack="returnToTickets"
          />
        </b-col>
      </b-row>
      <div class="pb-5">
        <b-row v-for="message in ticketData.conversation.messages" :key="message.id">
          <div class="w-100">

            <div class="">
              <p class="mb-1 text-center">
                <span class="text-muted small"
                      :title="formatDate(message.delivered_at)">{{ formatRelativeDate(message.delivered_at) }}</span>
              </p>
            </div>

            <b-card class="font-jumper"
                    :class="message.from_field.username && message.from_field.username.includes('@acounto_user') ? 'message-card' : 'message-card-acounto'"
                    @click="toggleExpand(message)">
              <div :key="forceUpdateKey" v-html="getFormattedMessage(message)"/>
            </b-card>

          </div>
        </b-row>
      </div>

      <div class="newMessageFormContainer" v-if="!ticketData.isClosed">
        <div class="grad"></div>
        <div class="newMessageForm">
          <input v-model="newMessage" class="invisible-input" placeholder="Írj üzenetet..." />
          <button @click="sendMessage" :disabled="!disableButtons"><i class="fa fal fa-paper-plane"></i></button>
        </div>
        <div class="closeThreadBtn">
          <button @click="closeTicket" :disabled="!disableButtons"><i class="fa fal fa-message-xmark"></i></button>
        </div>
      </div>

    </b-container>

  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Api from "api-client";
import {mapGetters} from "vuex";
import Util from "@/utils/Util";
import moment from "moment";
import 'moment/locale/hu';

export default {
  name: "Ticket",
  components: {
    PageHeader,
  },
  data() {
    return {
      ticketData: {},
      forceUpdateKey: 0,
      newMessage: "",
      disableButtons: false,
      textAreaOpened: false,
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  methods: {
    getData() {
      this.disableButtons = false
      Api.getTicket(this.$route.params.uuid, this.getActiveCompany.id)
          .then((resp) => {
            // Process the API response data
            resp.data.conversation.messages.forEach(message => {
              if (message.from_field.username === null) {
                message.from_field.username = "@acounto_support";
              }
            });
            this.ticketData = resp.data;
            this.ticketData.conversation.messages.sort((a, b) => a.delivered_at - b.delivered_at);
            this.ticketData.conversation.messages.forEach((msg) => {
              msg.turnicated = true
            })
            this.disableButtons = true
          })
          .catch(() => {
            // Use mocked data when API call fails
            const mockData = {};

            // Process the mock data the same way as the API response
            mockData.conversation.messages.forEach(message => {
              if (message.from_field.username === null) {
                message.from_field.username = "@acounto_support";
              }
            });
            this.ticketData = mockData;
            this.ticketData.conversation.messages.sort((a, b) => a.delivered_at - b.delivered_at);
            this.ticketData.conversation.messages.forEach((msg) => {
              msg.turnicated = true
            });
            this.disableButtons = true;

            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("tasks.failedGetTask"),
            });
          });
    },
    returnToTickets() {
      this.$router.go(-1)
    },
    toggleExpand(message) {
      message.turnicated = !message.turnicated
      this.forceUpdateKey++;
    },
    getMessage(message) {
      return message.body.length > 200 && message.turnicated ? message.body.substring(0, 200) + '...' : message.body;
    },
    getFormattedMessage(message) {
      const body = this.getMessage(message);
      return body.replace(/\n/g, '<br>');
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return `${year}.${month}.${day} ${hours}:${minutes}`;
    },
    formatRelativeDate(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return moment(`${year}.${month}.${day} ${hours}:${minutes}`).fromNow();
    },
    sendMessage() {
      this.disableButtons = false
      return Api.sendMessage(this.ticketData.uuid, this.newMessage, this.getActiveCompany.id).then(() => {

        this.newMessage = ""
        this.getData()
        this.$toast.success({
          title: "Sikeres üzenetküldés!",
          message: "Kollégáink hamarosan válaszolnak!",
        });
        Util.clearValidationErrors(
            document.getElementById("ticket-view")
        );

        this.disableButtons = true;
        this.toggleTextArea();
      }).catch((err) => {
        this.$toast.error({
          title: "Sikertelen üzenetküldés!",
          message: "Kérünk próbáld meg újra!",
        });
        if (err.isAxiosError && err.response.data.failList) {
          setTimeout(() => {
            Util.clearValidationErrors(
                document.getElementById("ticket-view")
            );
            Util.showValidationErrors(err, this.$refs);
          }, 100);
        }
        this.disableButtons = true;
      });
    },
    closeTicket() {
      this.disableButtons = false
      return Api.closeTicket(this.ticketData.uuid, this.getActiveCompany.id).then(() => {
        this.disableButtons = true;
        this.newMessage = ""
        this.getData()
        this.$toast.success({
          title: "Sikeres lezárás!",
          message: "Sikeres lezárás!",
        });
      }).catch(() => {
        this.$toast.error({
          title: "Sikertelen lezárás!",
          message: "Kérünk próbáld meg újra!",
        });
        this.disableButtons = true;
      });
    },
    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },
    toggleTextArea() {
      this.textAreaOpened = !this.textAreaOpened;
    },
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped>
@media (min-width: 768px) {
  .bottom-buttons .first {
    float: left;
  }

  .bottom-buttons .second {
    margin: 0 auto;
  }

  .bottom-buttons .third {
    float: right;
  }
}

.bottom-buttons .btn {
  width: 125px !important;
}

.bottom-buttons > div > div {
  margin: 0 auto;
}

.max-content {
  width: max-content;
}

.bottom-buttons .btn {
  color: white;
}

.custom-thumbnail {
  cursor: pointer;
  max-width: 128px;
  max-height: 128px;
  height: 128px;
  min-width: 72px;
  background-color: #eee;
  border-radius: 5px;
  position: relative;
  border: 1px solid gray;
}

.custom-image-preview {
  max-height: 128px;
  max-width: 128px;
  width: 100%;
  height: 100%;
}

.file-label-hack {
  position: absolute;
  bottom: -19px;
}

.file-text {
  display: block;
  width: 70px;
}

.custom-thumbnail-image {
  border-radius: 5px;
}

.nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-file-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 30px;
  height: 45px;
}

.message-card {
  width: 90%;
  margin-bottom: 30px;
  font-size: 14px !important;
}

.message-card-acounto {
  width: 90%;
  background-color: #252734 !important;
  color: white !important;
  float: right;
  margin-bottom: 30px;
  font-size: 14px !important;
}

.card-body {
  padding-bottom: 0px !important;
  margin-bottom: 12px;
}

.textarea-container {
  position: relative;
  margin-bottom: 12px;
}

.textarea-container .send-button {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.close-button {
  width: 240px;
  text-align: center;
  background-color: #FFA800;
  color: #FFFFFF;
  font-size: 24px;
  margin-bottom: 12px;
  margin-left: 12px;
}

.new-msg {
  width: 240px;
  text-align: center;
  color: #FFFFFF;
  font-size: 24px;
  margin-bottom: 12px;
}

.custom-container {
  margin-bottom: 30px;
}

.newMessageFormContainer {
  position: fixed;
  bottom: 0;
  right: 0;
  width: calc(100vw - 334px);
  padding: 15px;
  background-color: #F1F5F6;
  display: flex;
  align-items: center;
  z-index: 1000;
}

@media (max-width: 767px) {
  .newMessageFormContainer {
    width: 100%;
    left: 0;
    right: auto;
  }
}

.grad {
  height: 120px;
  background: linear-gradient(to top, rgba(240, 244, 245, 1) 0%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  bottom: 85px;
  left: 0;
  width: 100%;
  z-index: 999;
}

.newMessageForm {
  display: flex;
  flex: 1;
  margin-right: 10px;
  background-color: white;
  border-radius: 32px;
  border: 1px solid #AEBFC7;
  padding: 5px 5px 5px 20px;
  align-items: center;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.15);
}

.newMessageForm input {
  flex: 1;
  border: none;
  font-size: 16px !important;
  outline: none;
  height: 40px;
}

.newMessageForm button {
  border: 1px solid #AEBFC7;
  cursor: pointer;
  background-color: transparent;
  border-radius: 50%;
  padding: 8px;
  width: 45px;
  height: 45px;
  margin-left: 10px;
}

.closeThreadBtn {
  display: flex;
  align-items: center;
}

.closeThreadBtn button {
  border: 1px solid #AEBFC7;
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  padding: 10px;
  width: 50px;
  height: 50px;
  font-size: 18px;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.15);
}
</style>